export default (extraBaseClassName) => {
  const button = document.createElement('button');
  button.classList.add('video-player-c-basis');
  extraBaseClassName && button.classList.add(`${extraBaseClassName}__video-player-btn`);
  button.type = 'button';
  button.setAttribute('aria-label', 'Pause video');
  button.innerHTML = `
    <div class="video-player-c-basis__inner-content">
      <span class="pause" aria-hidden="true">
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.333334V9.66667H2.66667V0.333334H0ZM5.33333 0.333334V9.66667H8V0.333334H5.33333Z" fill="black"></path>
        </svg>
      </span>
      <span class="play" aria-hidden="true">
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.666626 0.777802V13.2222L11.3333 7.00002L0.666626 0.777802Z" fill="black"></path>
        </svg>
      </span>
    </div>
    <span class="visually-hidden">Pause</span>
  `;
  return button;
};
